/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/DocumentScannerGuidanceVisibility.yaml

/**
Determines the visibility mode for the document capturing user guidance labels.

- `ENABLED`:
   Enabled for both 'auto snapping' and 'manual snapping' modes.
- `AUTO_CAPTURE_ONLY`:
   Enabled only for the 'auto snapping' mode.
- `DISABLED`:
   Disabled for both 'auto snapping' and 'manual snapping' modes.
*/
export type UserGuidanceVisibility = 'ENABLED' | 'AUTO_CAPTURE_ONLY' | 'DISABLED';

export const UserGuidanceVisibilityValues: UserGuidanceVisibility[] = ['ENABLED', 'AUTO_CAPTURE_ONLY', 'DISABLED'];
